import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getTreatmentScheduleGroupsQueryKey = () => ["getTreatmentScheduleGroups"] as const;

export const useGetTreatmentScheduleGroups = () => {
  const client = useApiClient();

  return useQuery(getTreatmentScheduleGroupsQueryKey(), () => client.getTreatmentScheduleGroups());
};
